import { render } from "./FooterTemplate.vue?vue&type=template&id=897b40fc"
import script from "./FooterTemplate.vue?vue&type=script&lang=js"
export * from "./FooterTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__